/** Copy — Hub TNO Media Lab (tnomedialab.com): ecosistema completo. */

export const hubHero = {
  brand: 'TNO Media Lab',
  title: 'El laboratorio donde se producen shows, se construye software y crece la comunidad TNO.',
  subtitle:
    'Somos el brazo de producción, tecnología y comunidad de TNO Network: estudio audiovisual, soluciones digitales con cherryDev y una red de creadores que estrenan, distribuyen y escalan.',
  ctaPrimary: 'Explorar el ecosistema',
  ctaPrimaryHref: '#ecosistema',
  ctaSecondary: 'Ir a TNO Network',
  ctaSecondaryHref: 'https://www.tnonetwork.com',
  panelLabel: 'Explora ahora',
  panelTitle: 'Atajos del ecosistema',
  shortcuts: [
    {
      id: 'productora',
      label: 'Productora AV',
      hint: 'Shows · vivo · network',
      href: '/creadores',
      icon: 'voice',
      color: 'primary',
    },
    {
      id: 'cherry-dev',
      label: 'cherryDev',
      hint: 'Software a medida',
      href: '/cherry-dev',
      icon: 'code',
      color: 'secondary',
    },
    {
      id: 'cherry-web',
      label: 'Webs & tiendas',
      hint: 'Desde $80 · 7 días',
      href: '/cherry-web',
      icon: 'web',
      color: 'primary',
    },
    {
      id: 'creadores',
      label: 'Comunidad',
      hint: 'Creadores TNO',
      href: '/creators-guild',
      icon: 'team',
      color: 'secondary',
    },
    {
      id: 'network',
      label: 'TNO Network',
      hint: 'Streaming · on-demand',
      href: 'https://www.tnonetwork.com',
      icon: 'public',
      color: 'primary',
      external: true,
    },
  ],
};

export const hubAbout = {
  overline: 'Qué es TNO Media Lab',
  title: 'Un solo ecosistema. Varias puertas de entrada.',
  subtitle:
    'TNO Media Lab no es solo un estudio. Es la casa operativa de TNO Network: producimos contenido, desarrollamos tecnología y conectamos creadores con audiencia, marcas y herramientas.',
};

export const hubPillars = {
  overline: 'Ecosistema',
  title: 'Elige cómo quieres trabajar con nosotros',
  subtitle:
    'Cada brazo tiene su propia landing. Entra al que necesitas — o recorre todos.',
  items: [
    {
      id: 'productora',
      tag: 'Producción AV',
      title: 'Productora de shows',
      text:
        'Tú llegas con el programa. El Lab pone estudio, equipo y estreno en vivo. El show queda en on-demand, clips, tnonetwork.com y tus plataformas.',
      href: '/creadores',
      cta: 'Ver productora',
      icon: 'voice',
      color: 'primary',
    },
    {
      id: 'cherry-dev',
      tag: 'Brazo tecnológico',
      title: 'cherryDev — software a medida',
      text:
        'Sistemas Full Stack para operar sin límites: contable, e-commerce de alta capacidad, agendamiento, APIs y automatización interna.',
      href: '/cherry-dev',
      cta: 'Ver cherryDev',
      icon: 'code',
      color: 'secondary',
      featured: true,
    },
    {
      id: 'cherry-web',
      tag: 'Webs & tiendas',
      title: 'Webs y tiendas online',
      text:
        'Landings, sitios y e-commerce listos en días: dominio, hosting, WhatsApp y planes desde $80 para emprendedores que quieren vender en automático.',
      href: '/cherry-web',
      cta: 'Ver planes web',
      icon: 'web',
      color: 'primary',
    },
    {
      id: 'creadores',
      tag: 'Comunidad',
      title: 'Comunidad Creadores TNO',
      text:
        'La comunidad de hosts, productores y talentos de TNO Network: networking, eventos y la puerta de entrada para sumarte al ecosistema.',
      href: '/creators-guild',
      cta: 'Unirme a la comunidad',
      icon: 'team',
      color: 'secondary',
    },
    {
      id: 'network',
      tag: 'Network',
      title: 'TNO Network',
      text:
        'La red de contenidos: streaming en vivo, catálogo on-demand, shows por nicho y comercialización para marcas que buscan audiencia real.',
      href: 'https://www.tnonetwork.com',
      cta: 'Ir a tnonetwork.com',
      icon: 'public',
      color: 'primary',
      external: true,
    },
    {
      id: 'talentos',
      tag: 'Talento',
      title: 'Talentos y shows',
      text:
        'Conoce el flujo de producción para creadores y cómo tu show se estrena en vivo y se distribuye en toda la network.',
      href: '/talentos',
      cta: 'Ver para talentos',
      icon: 'stars',
      color: 'secondary',
    },
  ],
};

export const hubNetwork = {
  overline: 'TNO Network',
  title: 'Producción + distribución + tecnología',
  subtitle:
    'El Lab alimenta la network: shows que se estrenan en vivo, software que opera el negocio y una comunidad que no para de crear.',
  points: [
    {
      title: 'Contenido con antena',
      text: 'Premiere en streaming en vivo, vida on-demand y clips en redes.',
      icon: 'launch',
    },
    {
      title: 'Tech que escala',
      text: 'cherryDev construye las plataformas y sistemas que el negocio necesita.',
      icon: 'dashboard',
    },
    {
      title: 'Comunidad que crece',
      text: 'Creadores, hosts y productores conectados bajo el paraguas TNO.',
      icon: 'team',
    },
  ],
};

export const hubCta = {
  overline: 'Siguiente paso',
  title: 'Cuéntanos qué necesitas',
  subtitle:
    'Producción de show, software a medida, web/tienda o unirte a la comunidad: te orientamos por WhatsApp.',
  bullets: [
    'Productora audiovisual',
    'cherryDev / sistemas a medida',
    'Webs y e-commerce',
    'Comunidad de creadores',
  ],
  cta: 'Escribir por WhatsApp',
  secondaryCta: 'Ir a TNO Network',
  secondaryHref: 'https://www.tnonetwork.com',
  copyright: `© ${new Date().getFullYear()} TNO Network · TNO Media Lab · cherryDev`,
};

export const HUB_PAGE_TITLE = 'TNO Media Lab | Producción, tecnología y comunidad TNO';
export const HUB_PAGE_DESCRIPTION =
  'TNO Media Lab: productora audiovisual, brazo tecnológico cherryDev, webs/tiendas y comunidad de creadores de TNO Network.';
